import type { AvailableActionOption, Game, Member } from '../../types/game'
import { MobileFlowerTile } from './MobileFlowerTile'

interface MobilePollinatePanelProps {
  game: Game
  member: Member
  availableActions: AvailableActionOption[]
  activePanel: string | null
  onPollinate: (flowerId: number) => void
  onClose: () => void
}

export function MobilePollinatePanel({
  game,
  member,
  availableActions,
  activePanel,
  onPollinate,
  onClose,
}: MobilePollinatePanelProps) {
  const player = game.players.find((candidate) => candidate.color === member.color) ?? null
  const pollinatedIds = new Set(player?.pollinated_flowers.map((flower) => flower.id) ?? [])

  return (
    <div id="mobile-pollinate" className={`mobile-panel modal-panel mobile-pollinate${activePanel === 'pollinate' ? ' open' : ''}`}>
      <div className="mobile-panel-shell">
        <div className="mobile-panel-header">
          <div className="mobile-panel-title-main">Pollinate</div>
          <div id="mobile-close-pollinate" className="mobile-panel-close lobby-start" onClick={onClose}>Close</div>
        </div>
        <div id="mobile-pollinate-grid" className="mobile-flower-grid mobile-pollinate-grid">
          {player?.flowers.length ? (
            <>
              {player.flowers.map((flower) => (
                <MobileFlowerTile
                  key={flower.id}
                  flower={flower}
                  currentSeason={game.current_season}
                  pollinatedByColor={pollinatedIds.has(flower.id) ? player.color : null}
                  onClick={() => onPollinate(flower.id)}
                />
              ))}
              {player.flowers.length % 2 === 1 ? <div className="mobile-flower-placeholder" /> : null}
            </>
          ) : (
            <>
              <div className="mobile-flower-placeholder">No flowers available</div>
              <div className="mobile-flower-placeholder" />
            </>
          )}
        </div>
      </div>
    </div>
  )
}
